import i18next from 'i18next';
import { useTranslation } from 'i18next-vue';

import { AppLocale } from '@shared/i18n';
import childSelectRU from './ru.json';
import childSelectKK from './kk.json';

const NAMESPACE_NAME = 'child-select';

export function useChildSelectLocales() {
  if (i18next.language === AppLocale.RU) {
    i18next.addResourceBundle(
      AppLocale.RU,
      NAMESPACE_NAME,
      childSelectRU,
      true,
    );
  } else {
    i18next.addResourceBundle(
      AppLocale.KK,
      NAMESPACE_NAME,
      childSelectKK,
      true,
    );
  }

  return useTranslation(NAMESPACE_NAME);
}
